import React, { FC, memo, useEffect, useMemo, useRef, useState } from 'react'
import { Heading } from '@ucheba/ui/components/Heading/desktop'
import styled, { StyledProps } from 'styled-components'
import { Grid, GridCol } from '@ucheba/ui/components/Grid/desktop'
import { Spacing } from '@ucheba/ui/components/Spacing/desktop'
import { Text } from '@ucheba/ui/components/Text/desktop'
import { EColor, EColorBgText } from '@ucheba/utils/helpers/styles/variables'
import { IEventsHero } from '../types'
import { headerHeight } from '../../../../Header/constants'

const Image = styled.img`
  width: 100%;
`

const HeroBlock = styled.div<StyledProps<any>>`
  padding-top: ${headerHeight.desktop}px;
  margin-top: -${headerHeight.desktop}px;
  width: 100%;
  top: 0;
  left: 0;
  z-index: -1;
  position: absolute;
  height: ${(props) => (props.height ? props.height : '590px')};
  background-color: ${(props) => EColor[props.color]};
`

const EventsHero: FC<IEventsHero> = (props) => {
  const { name, description, branding, eventId } = props
  const contentBlockRef = useRef<any>()
  const [heightState, setHeightState] = useState<number | undefined>()

  useEffect(() => {
    if (contentBlockRef.current) {
      setHeightState(contentBlockRef.current.clientHeight + headerHeight.desktop * 2)
    }
  }, [contentBlockRef])

  const contentCols = useMemo(() => {
    // временный костыль, нужно убрать
    if (eventId === 5547 || eventId === 5570) return 18

    if (branding) {
      return branding.headerImagePath ? 13 : 24
    }

    return 24
  }, [branding, eventId])

  const imageCols = useMemo(() => {
    // временный костыль, нужно убрать
    if (eventId === 5547 || eventId === 5570) return 6

    return 11
  }, [eventId])

  if (branding) {
    return (
      <>
        <div ref={contentBlockRef}>
          <Spacing spacing='xlarge' />

          <Grid justifyContent='space-between'>
            <GridCol uxs={contentCols}>
              <Heading
                h1={name}
                color={EColorBgText[branding.headerBackgroundColor || 'white']}
              />

              <Text color={EColorBgText[branding.headerBackgroundColor || 'white']}>
                {description}
              </Text>

              <Spacing spacing='xxlarge' />
            </GridCol>

            {branding.headerImagePath && (
              <GridCol uxs={imageCols}>
                <Image
                  src={branding.headerImagePath}
                  onLoad={() => {
                    if (contentBlockRef.current.clientHeight) {
                      setHeightState(
                        contentBlockRef.current.clientHeight + headerHeight.desktop * 2
                      )
                    }
                  }}
                />

                <Spacing spacing='xxlarge' />
              </GridCol>
            )}
          </Grid>
        </div>

        <HeroBlock color={branding.headerBackgroundColor} height={`${heightState}px`} />
      </>
    )
  }

  return (
    <>
      <Heading h1={name} />

      <Spacing spacing='xxlarge' />
    </>
  )
}

export default memo(EventsHero)
